import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateFindChat = {
  findChat: { data: null, loading: false, error: null },
};

export const findChat = createAsyncThunk('user/findChat', async (data = {}, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .get(`${process.env.REACT_APP_SERVER_API}/chat/chats/search`, {
      params: data,
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerFindChat = {
  [findChat.pending]: (state) => {
    // state.findChat.data = null;
    state.findChat.loading = true;
    state.findChat.error = null;
  },
  [findChat.fulfilled]: (state, action) => {
    state.findChat.loading = false;
    state.findChat.data = action.payload;
    state.findChat.error = null;
  },
  [findChat.rejected]: (state, action) => {
    state.findChat.loading = false;
    state.findChat.error = action.payload;
  },
};
